import { render, staticRenderFns } from "./header_menu.vue?vue&type=template&id=5df84828&scoped=true"
import script from "./header_menu.vue?vue&type=script&lang=js"
export * from "./header_menu.vue?vue&type=script&lang=js"
import style0 from "./header_menu.vue?vue&type=style&index=0&id=5df84828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df84828",
  null
  
)

export default component.exports